/**
 * Scene reconciler config.
 */
export type SceneReconcilerConfig = {
  frustumCulling: boolean;
  garmentGeometryResource: boolean;
  // hideAvatar: boolean;
  // hideBackground: boolean;
  // hideGarmentHems: boolean;
  // hideGarmentPieces: boolean;
  // hideGarmentSeams: boolean;
  // hideGround: boolean;
  // hideLogos: boolean;
  hideStitches: boolean;
  useStitchesDecals: boolean;
};

/**
 * Create scene reconciler config.
 */
export const create = (() => {
  const ConfigDef: SceneReconcilerConfig = {
    frustumCulling: true,
    garmentGeometryResource: true,
    // hideAvatar: true,
    // hideBackground: true,
    // hideGarmentHems: false,
    // hideGarmentPieces: false,
    // hideGarmentSeams: false,
    // hideGround: true,
    // hideLogos: false,
    hideStitches: false,
    useStitchesDecals: true,
  };

  return (config?: Partial<SceneReconcilerConfig>) => {
    config ??= {};
    const all = { ...ConfigDef, ...config };
    return all;
  };
})();
